import service from '../utils/request'

export const getUsers = async (pageNumber, keyword) => {
    return service({
        url: '/user/list?pageNum=' + pageNumber + "&keyword=" + keyword + "&pageSize=10",
        method: 'get'
    })
}

export const getUser = async (id) => {
    return service({
        url: '/user/' + id,
        method: 'get'
    })
}

export const getMenus = async () => {
    return service({
        url: '/menu/list',
        method: 'get'
    })
}

export const isToHome = () => {
    return service({
        url: '/user/is_to_home',
        method: 'get'
    })
}